import { Outlet } from "react-router-dom";
import Sidebar from "../modules/Sidebar";
import AppHeader from "../modules/Header";
import AppRail from "../modules/Rail";
import "../assets/scss/style.scss";
import { Layout } from "antd";
import { localStorageUtil } from "../utils/CommonFunctions";
import { useUserSelfStore } from "../store/apis/useUserStore";
import { useEffect } from "react";
import MessageSearchSection from "../sections/MessageSearchSection";
import { useBridgeStore } from "../store/apis/useBridgeStore";
const { Header: AntHeader, Sider, Content } = Layout;

const MainLayout = () => {
  const UserData = localStorageUtil.getItem("userData");
  const globalSectionConfig = useBridgeStore(
    (state) => state.globalSectionConfig
  );
  const setGlobalSectionConfig = useBridgeStore((store)=>store.setGlobalSectionConfig)


  const getUserSelfDetails = useUserSelfStore(
    (store) => store.getUserSelfDetails
  );

  useEffect(() => {
    if (UserData) {
      getUserSelfDetails(UserData._id);
    }
  }, []);

  return (
    <>
      <Layout className="app-wrapper">
        {/* Small screens only: the rail and chat list move into its drawer */}
        <AntHeader className="header">
          <AppHeader />
        </AntHeader>

        <Layout className="app-body-wrapper">
          <AppRail />

          <Sider className="ec-sidebar" width={340}>
            <Sidebar />
          </Sider>

          <Content className="app-body">
            <div className="app-content-wrapper">
              <Outlet />
              {globalSectionConfig.openedSection == "MessageSearchSection" && (
                <MessageSearchSection
                  isExpanded={globalSectionConfig.isExpanded}
                  onSectionUpdate={setGlobalSectionConfig}
                />
              )}
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default MainLayout;
